<template>
  <div class="wrapper">
    <div class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-33 md-small-size-66 md-xsmall-size-100 md-medium-size-40 mx-auto"
          >
            <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(onReset)">
                <md-card class="md-card-login">
                  <md-card-header class="md-card-header-primary">
                    <h4 class="card-title">{{$t('Forgot password?')}}</h4>
                  </md-card-header>

                  <md-card-content>
                    <br />

                    <validation-provider rules="required" v-slot="v">
                      <md-field class="md-form-group" :class="{'md-invalid md-error' : v.failed}">
                        <md-icon>account_circle</md-icon>
                        <label class="required">{{ $t('Username') }}</label>
                        <md-input v-model="model.username" />
                      </md-field>
                      <p class="md-error">
                        <span v-for="error in v.errors" :key="error">{{error}}</span>
                      </p>
                    </validation-provider>
                  </md-card-content>

                  <md-card-actions>
                    <md-button
                      class="md-round md-sm md-blue-border md-primary"
                      type="submit"
                    >{{ $t('reset password') }}</md-button>
                  </md-card-actions>

                  <md-card-actions>
                    <md-button
                      class="md-simple md-link md-sm"
                      @click="onBackToLoginPage"
                    >{{ $t('back to login page') }}</md-button>
                  </md-card-actions>
                </md-card>
              </form>
            </validation-observer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/util/axios";
import { mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import Mixins from "@/plugins/basicMixins";

extend("required", required);

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  mixins: [Mixins.HeaderImage],
  bodyClass: "login-page",
  computed: {
    ...mapGetters({ language: "language/current" })
  },
  data() {
    return {
      image: require("@/assets/img/background.png"),

      model: {
        username: null
      }
    };
  },
  methods: {
    async onReset() {
      let loader = this.$loading.show();

      try {
        let result = await axios.post("auth/forgotPassword", this.model);

        this.$swal({
          icon: "success",
          title: this.$t("Sent"),
          text: this.$t("Email has been sent.")
        });
        this.$router.push({ name: "login" });
      } catch (exception) {
        console.log(exception);
        alert(exception);
      } finally {
        loader.hide();
      }
    },
    onBackToLoginPage() {
      this.$router.push({ name: "login" });
    }
  },
  watch: {
    language() {
      this.$refs.formValidator.validate();
    }
  }
};
</script>

<style lang="css"></style>
